import { Timestamp } from 'firebase/firestore';

import { AthleteWithId, SkillValues } from '../../types/athlete';
import { FormSchema, normalizeFormSchema } from '../../types/formSchema';
import demoData from '../data/demoData.json';
import gryphonsTemplates from '../data/exampletryoutschemagryphons.json';
import { DemoCoach, DemoTryoutMeta, SeedAthlete } from './types';

/**
 * The gryphons file is a FormTemplate[]; we use the first template's schema.
 * Swap which file is imported above to change the demo form.
 */
function loadDemoFormSchema(): FormSchema {
  const first = (gryphonsTemplates as Array<{ schema?: { groups?: unknown } }>)[0];
  const groups = first?.schema?.groups;
  if (!Array.isArray(groups)) return { groups: [] };
  return normalizeFormSchema({ groups: groups as FormSchema['groups'] });
}

export const SEED_TRYOUT_META: DemoTryoutMeta = {
  name: demoData.tryout.name,
  code: demoData.tryout.code,
  password: demoData.tryout.password,
  gymLogoUrl: demoData.tryout.gymLogoUrl ?? null,
  athletePositions: demoData.tryout.athletePositions,
  athleteStatuses: demoData.tryout.athleteStatuses,
  teams: demoData.tryout.teams,
  formSchema: loadDemoFormSchema(),
};

export const SEED_COACH: DemoCoach = {
  uid: 'demo-coach-uid',
  name: demoData.coach.name,
};

export const SEED_ATHLETES_RAW: SeedAthlete[] = demoData.athletes as SeedAthlete[];

export const ADD_ATHLETE_PREFILL = demoData.addAthletePrefill;

/** Athletes pre-pinned to the quick-access tab bar on first load. */
export const SEED_TABBED_ATHLETE_IDS: string[] = (
  Array.isArray((demoData as { defaultTabbedAthleteIndices?: number[] }).defaultTabbedAthleteIndices)
    ? (demoData as { defaultTabbedAthleteIndices: number[] }).defaultTabbedAthleteIndices
    : []
).map((i) => seedAthleteId(i));

/** Stable ID derived from seed index — survives reloads so overlays match. */
export function seedAthleteId(index: number): string {
  return `demo-seed-${index}`;
}

const SEED_CREATED_AT = Timestamp.fromMillis(0);

export function buildSeedAthletes(): AthleteWithId[] {
  return SEED_ATHLETES_RAW.map((a, i): AthleteWithId => ({
    id: seedAthleteId(i),
    name: a.name,
    number: a.number,
    position: a.position,
    returningstatus: a.returningstatus,
    createdAt: SEED_CREATED_AT,
    createdBy: SEED_COACH.uid,
    scores: (a.scores ?? {}) as SkillValues,
    teamPlacement: a.teamPlacement ?? null,
    imageUrl: a.imageUrl,
    imageThumbnailUrl: a.imageThumbnailUrl,
  }));
}
